import StopIcon from "@mui/icons-material/Stop";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Tooltip } from "@mui/material";
import { ListeningWave, MicButton, SendButton, WaveBar } from "./styles";

const LISTENING_WAVE_BARS = [
  { duration: "0.9s", delay: "0s" },
  { duration: "1.1s", delay: "0.1s" },
  { duration: "0.8s", delay: "0.2s" },
  { duration: "1.2s", delay: "0.05s" },
  { duration: "1s", delay: "0.15s" },
  { duration: "0.85s", delay: "0.25s" },
  { duration: "1.15s", delay: "0.1s" },
];

type Props = {
  onStop: () => void;
  onSend: () => void;
};

export const RecordingIndicator = ({ onStop, onSend }: Props) => (
  <>
    <ListeningWave aria-hidden>
      {LISTENING_WAVE_BARS.map((bar, index) => (
        <WaveBar key={index} $duration={bar.duration} $delay={bar.delay} />
      ))}
    </ListeningWave>
    <Tooltip title="Stop" placement="top">
      <MicButton type="button" $isListening onClick={onStop} aria-label="Stop">
        <StopIcon />
      </MicButton>
    </Tooltip>
    <Tooltip title="Send" placement="top">
      <SendButton type="button" onClick={onSend} aria-label="Send">
        <ArrowUpwardIcon />
      </SendButton>
    </Tooltip>
  </>
);
